import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import commonApi from '../../api/common.api';
import { IPageMetadata } from '../../datatypes/CommonTypes';

type MetadataStateType = {
  loading: boolean;
  metadata: IPageMetadata[];
  defaultMetadata: IPageMetadata | null;
  error: boolean;
};
const initialState: MetadataStateType = {
  loading: true,
  metadata: [],
  defaultMetadata: null,
  error: false,
};

export const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(fetchPagesMetadata.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPagesMetadata.fulfilled, (state, action) => {
        state.metadata = action.payload.metadata;
        state.defaultMetadata = action.payload.defaultMetadata;
        state.loading = false;
        state.error = false;
      })
      .addCase(fetchPagesMetadata.rejected, (state) => {
        state.loading = false;
        state.metadata = [];
        state.defaultMetadata = null;
        state.error = true;
      });
  },
});

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(fetchPagesMetadata(PAGECODE))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const fetchPagesMetadata = createAsyncThunk(
  'page/fetchPagesMetadata',
  async () => {
    const metadataResponse = await commonApi().getPagesMetadata();
    // The value we return becomes the `fulfilled` action payload
    return metadataResponse;
  },
);
export default metadataSlice.reducer;
